import request from '@/utils/request'

// 1. 添加商品到购物车
// POST /api/frontend/cart/add
export function addCartItem(itemId, itemType, quantity = 1) {
  return request({
    url: '/api/frontend/cart/add',
    method: 'post',
    params: {
      itemId,
      itemType,
      quantity
    }
  })
}

// 2. 批量删除购物车中的商品
// DELETE /api/frontend/cart/batch
// 参数:
// - cartIds: 购物车ID列表 (Query Parameter, e.g., ?cartIds=1&cartIds=2)
export function batchDeleteCartItems(cartIds) {
  // Axios paramsSerializer handles array serialization if needed, 
  // but usually for 'cartIds=1&cartIds=2' style, params is sufficient with array.
  return request({
    url: '/api/frontend/cart/batch',
    method: 'delete',
    params: { cartIds },
    paramsSerializer: params => {
      return Object.keys(params).map(key => {
        const val = params[key]
        if (Array.isArray(val)) {
          return val.map(v => `${key}=${v}`).join('&')
        }
        return `${key}=${val}`
      }).join('&')
    }
  })
}

// 3. 批量结算
// POST /api/frontend/cart/checkout
// 请求参数 (Body):
// - cartIds: [1, 2, 3]
// - cashAmount: 100
// - coinAmount: 50
// - couponAmount: 30
// - couponId: 10
// - payType: 6
// - receiverAddress: "北京市朝阳区..."
// - receiverName: "张三"
// - receiverPhone: 13800138000
export function checkoutCart(data) {
  return request({
    url: '/api/frontend/cart/checkout',
    method: 'post',
    data
  })
}

// 4. 清空购物车
// DELETE /api/frontend/cart/clear
export function clearCart() {
  return request({
    url: '/api/frontend/cart/clear',
    method: 'delete'
  })
}

// 5. 查询当前用户的购物车列表
// GET /api/frontend/cart/list
export function getCartList() {
  return request({
    url: '/api/frontend/cart/list',
    method: 'get'
  })
}

// 6. 全选或取消全选
// PUT /api/frontend/cart/select-all
// 参数:
// - selected: 是否选中（0:否 1:是）
export function selectAllCartItems(selected) {
  return request({
    url: '/api/frontend/cart/select-all',
    method: 'put',
    params: { selected }
  })
}

// 7. 获取购物车中选中商品的数量
// GET /api/frontend/cart/selected-count
export function getSelectedCartCount() {
  return request({
    url: '/api/frontend/cart/selected-count',
    method: 'get'
  })
}

// 8. 删除单个商品
// DELETE /api/frontend/cart/{id}
export function deleteCartItem(id) {
  return request({
    url: `/api/frontend/cart/${id}`,
    method: 'delete'
  })
}

// 9. 更新购物车中商品的数量
// PUT /api/frontend/cart/{id}/quantity
// 参数:
// - quantity: 数量
export function updateCartItemQuantity(id, quantity) {
  return request({
    url: `/api/frontend/cart/${id}/quantity`,
    method: 'put',
    params: { quantity }
  })
}

// 10. 更新购物车中商品的选中状态
// PUT /api/frontend/cart/{id}/selected
// 参数:
// - selected: 是否选中（0:否 1:是）
export function updateCartItemSelected(id, selected) {
  return request({
    url: `/api/frontend/cart/${id}/selected`,
    method: 'put',
    params: { selected }
  })
}
